import { render, staticRenderFns } from "./TypeTemplate.vue?vue&type=template&id=185a4752"
import script from "./TypeTemplate.vue?vue&type=script&lang=js"
export * from "./TypeTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports